import { useEffect, useState } from "react";
import ProjectsTable from "./ProjectsTable";
import AnalyticsView from "./AnalyticsView";
import DevCentre from "./DevCentre";
import { useTakeoff } from "./store";

/** Version + release stamp of the ACTUALLY LOADED bundle. The deploy stamps
 *  public/version.json at image build time, so an old browser session shows
 *  ITS OWN version — comparing it with what the server reports is how you
 *  tell a stale tab apart. Toronto local time. Hidden when unstamped (dev).
 *  Lives on Estimate Home (top-right) — visible to Viewer users too. */
function VersionBadge() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch("/version.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d?.version) setInfo(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!info?.version) return null;
  let when = null;
  if (info.built_at) {
    when = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Toronto", month: "short", day: "numeric", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: true, timeZoneName: "short",
    }).format(new Date(info.built_at));
  }
  return (
    <p className="text-right font-mono text-[9px] uppercase leading-tight tracking-widest text-slate-400" data-testid="takeoff-version-badge" title="The build this session has loaded">
      Version {info.version}{when && <><br className="sm:hidden" /><span className="hidden sm:inline"> · </span>Released {when}</>}
    </p>
  );
}

/** Home view — Projects, Analytics and Developer Centre tabs.
 * Viewers (manager role) get Projects only — analytics carry financials and
 * the developer centre is an admin tool. */
export default function HomeView({ onOpenProject, onNewJob }) {
  const { viewer } = useTakeoff();
  const [tab, setTab] = useState("projects");
  const tabs = viewer ? [["projects", "Projects"]] : [["projects", "Projects"], ["analytics", "Analytics"], ["dev", "Developer Centre"]];
  return (
    <div className="mx-auto w-full max-w-[1400px] p-4 sm:p-6" data-testid="takeoff-home">
      <div className="mb-4 flex items-end gap-1 border-b border-slate-200">
        {tabs.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`takeoff-home-tab-${k}`}
            aria-pressed={tab === k}
            className={`-mb-px border-b-2 px-4 py-2 text-xs font-semibold uppercase tracking-widest transition-colors ${tab === k ? "border-[#f97316] text-slate-900" : "border-transparent text-slate-400 hover:text-slate-600"}`}>
            {l}
          </button>
        ))}
        <div className="ml-auto shrink-0 pb-1 pl-3">
          <VersionBadge />
        </div>
      </div>
      {tab === "projects"
        ? <ProjectsTable onOpenProject={onOpenProject} onNewJob={onNewJob} />
        : tab === "analytics"
          ? <AnalyticsView />
          : <DevCentre />}
    </div>
  );
}
